import styled, { css } from 'styled-components';
import { primaryColor, secondaryColor } from '../../../pages/dash/styles';

export const ActionCardContainer = styled.div`
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 220px;
`;

export const ActionIconContainer = styled.div`
  width: 78px;
  height: 78px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  font-size: 20px;
  
  background-color: ${props => {
    switch(props.type) {
      case 'evento': return '#DBEAFE';
      case 'curso': return '#F3E8FF';
      case 'oportunidade': return '#DCFCE7';
      default: return '#EEE';
    }
  }};
  
  color: ${props => {
    switch(props.type) {
      case 'evento': return primaryColor;
      case 'curso': return '#AB47BC';
      case 'oportunidade': return '#66BB6A';
      default: return '#333';
    }
  }};
`;

export const ActionCardTitle = styled.h4`
  font-size: 23px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 10px 0;
`;

export const ActionCardDescription = styled.p`
  font-size: 19px;
  color: #566474;
  margin: 0 0 20px 0;
  line-height: 1.4;
  flex-grow: 1;
`;

export const ActionButton = styled.button`
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  height: 55px;
  width: 100%;
  text-align: center;
  transition: opacity 0.2s;
  
  ${props => {
    switch(props.type) {
      case 'evento': return css`
        background-color: ${secondaryColor};
        color: #FFFFFF;
      `;
      case 'curso': return css`
        background-color: #A855F7;
        color: #FFFFFF;
      `;
      case 'oportunidade': return css`
        background-color: #16A34A;
        color: #FFFFFF;
      `;
      default: return css`
        background-color: #CCC;
        color: #333;
      `;
    }
  }}

  &:hover {
    opacity: 0.9;
  }
`;